/**
 * API pubblica Manuale Giochi (proxy cil-server).
 */

const buildQuery = (filters = {}) => {
  const p = new URLSearchParams();
  if (filters.page) p.append('page', String(filters.page));
  if (filters.pageSize) p.append('pageSize', String(filters.pageSize));
  if (filters.q) p.append('q', filters.q);
  if (filters.tipologia) p.append('tipologia', filters.tipologia);
  if (filters.competitivita) p.append('competitivita', filters.competitivita);
  if (filters.energia) p.append('energia', filters.energia);
  if (filters.complessita) p.append('complessita', filters.complessita);
  if (filters.rischio) p.append('rischio', filters.rischio);
  if (filters.durataMin != null && filters.durataMin !== '')
    p.append('durataMin', String(filters.durataMin));
  if (filters.durataMax != null && filters.durataMax !== '')
    p.append('durataMax', String(filters.durataMax));
  const csv = (key, arr) => {
    if (!Array.isArray(arr) || !arr.length) return;
    p.append(key, arr.join(','));
  };
  csv('categorieGioco', filters.categorieGioco);
  csv('meccanicheGioco', filters.meccanicheGioco);
  csv('fasceEta', filters.fasceEta);
  csv('spaziGioco', filters.spaziGioco);
  csv('obiettiviEducativi', filters.obiettiviEducativi);
  csv('materiali', filters.materiali);
  const qs = p.toString();
  return qs ? `?${qs}` : '';
};

export const fetchManualeGiochi = async (filters = {}) => {
  const query = buildQuery(filters);
  const res = await fetch(`/api/manuale-giochi${query}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Errore nel recupero dei giochi');
  }
  return res.json();
};

export const fetchManualeGiocoBySlug = async (slug) => {
  const res = await fetch(`/api/manuale-giochi/${encodeURIComponent(slug)}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Gioco non trovato');
  }
  return res.json();
};
